import React from 'react'
import VendorsMainPage from './components/VendorsMainPage'

const Vendors = () => {
  return (
    <VendorsMainPage/>
  )
}

export default Vendors